"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_FONT_SIZE = exports.DEFAULT_FONT_WEIGHT = exports.AXIS_POSITIONS = void 0;
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const colors_1 = require("../../utilities/colors");
const measurements_1 = require("../../utilities/measurements");
exports.AXIS_POSITIONS = lodash_1.default.keyBy(['top', 'right', 'bottom', 'left']);
exports.DEFAULT_FONT_WEIGHT = 400;
exports.DEFAULT_FONT_SIZE = 13;
exports.DEFAULT_TEXT_COLOR = '#4D4D4D';
const dataCheck = value => {
  if (typeof value === 'number') {
    return value;
  }
  if (value instanceof Date) {
    return value.getTime();
  }
  return undefined;
};
const Axis = _ref => {
  let {
    position,
    chartWidth,
    chartHeight,
    ticks,
    formatter = v => v,
    fontSize = exports.DEFAULT_FONT_SIZE,
    fontWeight = exports.DEFAULT_FONT_WEIGHT,
    opacity = 1,
    textColor = exports.DEFAULT_TEXT_COLOR,
    onClick = () => {},
    onMouseOver = () => {},
    onMouseOut = () => {}
  } = _ref;
  const isTop = position === exports.AXIS_POSITIONS.top;
  const isBottom = position === exports.AXIS_POSITIONS.bottom;
  const isLeft = position === exports.AXIS_POSITIONS.left;
  const isHorizontal = isTop || isBottom;
  const isVertical = !isHorizontal;
  let textAnchor = 'end';
  if (isHorizontal) {
    textAnchor = 'middle';
  }
  let dominantBaseline = 'auto';
  if (isVertical) {
    dominantBaseline = 'middle';
  } else if (isTop) {
    dominantBaseline = 'hanging';
  }
  const modTextColor = (0, colors_1.parseColor)(textColor, exports.DEFAULT_TEXT_COLOR);
  const tickData = (0, react_1.useRef)(ticks.map(_ref2 => {
    let {
      data
    } = _ref2;
    return data;
  }));
  const maxLabel = Math.max(...tickData.current.map(data => (0, measurements_1.textDimensions)({
    text: formatter(data, {
      ticks: tickData.current
    })
  }).width));
  const transitionedTicks = ticks.map((tick, i) => {
    const label = dataCheck(tick.data);
    let x = chartWidth;
    if (isHorizontal) {
      x = tick.point;
    } else if (isLeft) {
      x = maxLabel;
    }
    let y = chartHeight;
    if (isVertical) {
      y = tick.point;
    } else if (isTop) {
      y = 0;
    }
    return {
      ...(label !== undefined ? {
        label
      } : {}),
      // content: tick.data,
      key: label !== undefined ? label : i,
      x,
      y,
      fontSize,
      fontWeight,
      fill: modTextColor,
      opacity
    };
  });
  return react_1.default.createElement("g", {
    className: `${position}-axis-component`
  }, transitionedTicks.map((tick, i) => {
    if (ticks[i]) {
      tickData.current[i] = ticks[i].data;
    }
    return react_1.default.createElement("text", {
      key: tick.key || i,
      className: "axis-component-label",
      textAnchor: textAnchor,
      dominantBaseline: dominantBaseline,
      opacity: tick.opacity,
      fontSize: tick.fontSize,
      fontWeight: tick.fontWeight,
      fill: tick.fill,
      x: tick.x,
      y: tick.y,
      onMouseOver: event => onMouseOver(event, i),
      onMouseOut: event => onMouseOut(event, i),
      onClick: event => onClick(event, i)
    }, tick.label ? formatter(tick.label, {
      ticks: tickData.current
    }) : formatter(tickData.current[i], {
      ticks: tickData.current
    }));
  }));
};
Axis.propTypes = {
  /**
   * Position of the axis on the graph.
   */
  position: (0, prop_types_1.oneOf)(lodash_1.default.values(exports.AXIS_POSITIONS)).isRequired,
  /**
   * Total with of the chart.
   */
  chartWidth: prop_types_1.number.isRequired,
  /**
   * Total height of the chart.
   */
  chartHeight: prop_types_1.number.isRequired,
  /**
   * Ticks to be labelled on the axis
   *  Array of objects containing: data (label contents), point (x or y coorinate).
   */
  ticks: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    data: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number, prop_types_1.object]),
    point: prop_types_1.number
  })).isRequired,
  /**
   * Function used to format tick values.
   * First parameter is a tick and the second is an optional
   * object with a ticks key containing the ticks array.
   */
  formatter: prop_types_1.func,
  /**
   * Font size of axis labels.
   */
  fontSize: prop_types_1.number,
  /**
   * Font weight of axis labels.
   */
  fontWeight: prop_types_1.number,
  /**
   * Opacity of axis labels.
   */
  opacity: prop_types_1.number,
  /**
   * Color of axis labels. Accepts RGB and USAFacts specified colors.
   */
  textColor: prop_types_1.string,
  /**
   * function to activate on click
   * parameters: (event, index)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, index)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, index)
   */
  onMouseOut: prop_types_1.func
};
exports.default = Axis;